/**
 * @desc 获取库存成本
 */
const URL = "/rantion-fulfilment";
import http, { updateResponse } from "@/http";
export function request(body: defs.fulfilment.InventoryCostRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/test/getInventoryCost`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
